import { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import "../../style/style-cargando.css";
import cargandoCard from "../../components/cargando-card";
import { ESTILO_BOTON_MODAL_ACEPTAR } from "../../utils/const/estilos-const";
import sinAccesoCard from "../../components/sin-acceso-card";
// import { Settings } from "feather-icons-react/build/IconComponents";
import { sharedNextPage } from "../../utils/shared-functions";
// import ArrowBack from "../../../components/arrow-back";
import { useTranslation } from "react-i18next";
import ProcessingDialog from "../../components/processing-dialog";
import ToastComponent from "../../components/toast-component";
import { obtenerListaIncidenteMovil } from "../../api/api-incidente-movil";
import ModalMapaIncidente from "../../components/modal-mapa-incidente";
import Calendar from "../../components/calendar";
import moment from "moment";
import { STRING_ID_TIPO_USUARIO_WEB, STRING_SUPER_ADMIN, STRING_ID_ROL_USUARIO_WEB } from "../../utils/const/string-const";
import { obtenerPermisoRolUsuarioWeb } from "../../api/api-permiso-rol-usuario-web";
import { PAGE_ID } from "../usuarios/gestionar-rol-usuario-web/pages-const";

let $ = window.$;

export default function ListarIncidentesPage
  () {
  const idTipoUsuarioWeb = localStorage.getItem(STRING_ID_TIPO_USUARIO_WEB);
  const { t } = useTranslation();
  const history = useHistory();
  const [cargandoPage, setCargandoPage] = useState(true);
  // const [listaElementos, setListaElementos] = useState([]);
  const [elementoSelected, setElementoSelected] = useState(null);
  // const [permisos, setPermisos] = useState(null);
  const [tieneAccesoAlModulo, setTieneAccesoAlModulo] = useState(false);
  const [habilitadoSelected, setHabilitadoSelected] = useState(null);

  const [rowsData, setRowsData] = useState([]);
  const [modalMapaVisible, setModalMapaVisible] = useState(false);
  const [incidenteMapaSelected, setIncidenteMapaSelected] = useState(null);

  const [processingVisible, setProcessingVisible] = useState(false);
  const [toastVisible, setToastVisible] = useState(false);
  const [toastMessage, setToastMessage] = useState("");
  const [toastType, setToastType] = useState("warning"); // "warning" | "success" | "error"

  // Current ISO week: Monday (start) through Sunday (end)
  const [fechaInicioSelected, setFechaInicioSelected] = useState(() =>
    moment().startOf("isoWeek").format("YYYY-MM-DD")
  );
  const [fechaFinSelected, setFechaFinSelected] = useState(() =>
    moment().endOf("isoWeek").format("YYYY-MM-DD")
  );
  const [btnBuscar, setBtnBuscar] = useState(false);
  const [btnVer, setBtnVer] = useState(false);

  useEffect(() => {
    iniciar();
  }, []);

  const iniciar = async () => {
    let tieneAcceso = false;
    try {
      let objEnviar = {};
      objEnviar.habilitado = habilitadoSelected !== null ? habilitadoSelected.value : null;
      objEnviar.fechaInicio = fechaInicioSelected;
      objEnviar.fechaFin = fechaFinSelected;
      if (idTipoUsuarioWeb === STRING_SUPER_ADMIN) {
        tieneAcceso = true;
        setBtnBuscar(true);
        setBtnVer(true);
      }
      if (idTipoUsuarioWeb !== STRING_SUPER_ADMIN) {
        const idRolUsuarioWeb = localStorage.getItem(STRING_ID_ROL_USUARIO_WEB);
        objEnviar.idRolUsuarioWeb = idRolUsuarioWeb;
        const response = await obtenerPermisoRolUsuarioWeb(objEnviar);
        if (response.error === false && response.data !== undefined) {
          const permisos = JSON.parse(response.data.permisos);
          // console.log('permisos');
          // console.log(permisos);
          if (Array.isArray(permisos) && permisos.length > 0) {
            const manage = permisos.find(p => p.id === 7);
            if (manage !== undefined && manage !== null) {
              const permisosPage = manage.subMenu.find(p => p.value === PAGE_ID.LISTA_INCIDENTE);
              // console.log('permisosPage');
              // console.log(permisosPage);
              tieneAcceso = permisosPage.checked;
              if (tieneAcceso === false) {
                return;
              }
              const permisoBtnBuscar = permisosPage.acciones.find(a => a.value === 'btn_buscar');
              const permisoBtnVer = permisosPage.acciones.find(a => a.value === 'btn_ver');
              setBtnBuscar(permisoBtnBuscar?.checked);
              setBtnVer(permisoBtnVer?.checked);
            }
          }
        }
      }
      if (tieneAcceso === true) {
        let lista = [];

        lista = await obtenerListaIncidenteMovil(objEnviar);
        setRowsData(lista);
      }
    } catch (err) {
      console.log('iniciar err');
      console.log(err);
    } finally {
      setCargandoPage(false);
      setTieneAccesoAlModulo(tieneAcceso);
    }
  };

  useEffect(() => {
    // Small delay to ensure DOM is ready
    const timer = setTimeout(() => {
      const gridElement = $("#gridContainer");
      if (gridElement.length) {
        try {
          const gridInstance = gridElement.dxDataGrid("instance");
          if (gridInstance) {
            // Grid already exists, just update the data source
            gridInstance.option("dataSource", rowsData);
          } else {
            // Grid doesn't exist yet, initialize it
            inicializarGrid();
          }
        } catch (e) {
          // Grid doesn't exist yet, initialize it
          inicializarGrid();
        }
      }
    }, 100);

    return () => clearTimeout(timer);
  }, [rowsData]);

  const inicializarGrid = () => {
    try {
      const gridElement = $("#gridContainer");

      // Check if element exists
      if (!gridElement.length) {
        // console.warn("Grid container element not found");
        return;
      }

      // Initialize the grid
      gridElement.dxDataGrid({
        dataSource: rowsData,
        paging: {
          pageSize: 20,
        },
        pager: {
          showPageSizeSelector: true,
          allowedPageSizes: [50, 100, 150, 200],
        },
        remoteOperations: false,
        groupPanel: { visible: true },
        grouping: {
          autoExpandAll: false,
        },
        allowColumnReordering: true,
        rowAlternationEnabled: true,
        showBorders: true,
        columnAutoWidth: true,
        filterRow: {
          visible: true,
          applyFilter: "auto",
        },
        searchPanel: {
          visible: true,
          width: 240,
          placeholder: t("grilla_placeholderbuscar"),
        },
        export: {
          enabled: true,
        },
        headerFilter: {
          visible: true,
        },
        columns: [
          {
            dataField: "acciones",
            caption: t("column_acciones"),
            width: 150,
            allowFiltering: false,
            allowSorting: false,
            cellTemplate: function (container, options) {
              // console.log("cellTemplate acciones");
              // console.log('options', options);
              // console.log('options.data', options.data);
              const buttonContainer = $("<div>").addClass("flex gap-2");
              if (btnVer === true) {
                // Edit button
                $("<button>")
                  .addClass(
                    "px-3 py-1 bg-green-500 hover:bg-green-600 text-white rounded text-sm"
                  )
                  .text(t("btn_ver"))
                  .on("click", function () {
                    verElementoSelected(options.data);
                  })
                  .appendTo(buttonContainer);
              }

              buttonContainer.appendTo(container);
            },
          },
          {
            dataField: "id",
            caption: "ID",
            visible: false,
          },
          {
            dataField: "idEstadoIncidente",
            caption: "idEstadoIncidente",
            visible: false,
          },
          {
            dataField: "estadoIncidente",
            caption: t("column_estado_incidente"),
            visible: true,
          },
          {
            dataField: "idSubEstadoIncidente",
            caption: "idSubEstadoIncidente",
            visible: false,
          },
          {
            dataField: "subEstadoIncidente",
            caption: t("column_sub_estado_incidente"),
            visible: true,
          },
          {
            dataField: "labelPlaca",
            caption: t("column_placa"),
            width: 150,
          },
          {
            dataField: "nombreChofer",
            caption: t("column_nombre_chofer"),
            width: 150,
          },
          {
            dataField: "fechaHoraIncidente",
            caption: t("column_fecha_hora_incidente"),
            width: 150,
          },
          {
            dataField: "latitud",
            caption: t("column_latitud"),
            width: 150,
            cellTemplate: function (container, options) {
              $("<button>")
                .addClass("text-blue-600 hover:text-blue-800 underline")
                .text(options?.data?.latitud ?? "-")
                .on("click", function () {
                  abrirMapaIncidente(options.data);
                })
                .appendTo(container);
            },
          },
          {
            dataField: "longitud",
            caption: t("column_longitud"),
            width: 150,
            cellTemplate: function (container, options) {
              $("<button>")
                .addClass("text-blue-600 hover:text-blue-800 underline")
                .text(options?.data?.longitud ?? "-")
                .on("click", function () {
                  abrirMapaIncidente(options.data);
                })
                .appendTo(container);
            },
          },
          {
            dataField: "fechaRegistro",
            caption: t("column_fecha_registro"),
            width: 200,
          }
        ],
      });
    } catch (err) {
      console.error("Error initializing grid:", err);
    }
  };

  const verElementoSelected = (data) => {
    try {
      // console.log("verElementoSelected");
      // console.log(data);
      if (data.acciones !== undefined) {
        delete data.acciones;
      }
      let obj = {};
      obj.titulo = t("label_detalle_incidente");
      obj.params = data;
      // console.log('obj');
      // console.log(obj);
      sharedNextPage("detalle-incidente", obj, history);
    } catch (err) {
      console.log("verElementoSelected err");
      console.log(err);
    }
  };

  const abrirMapaIncidente = (obj) => {
    setIncidenteMapaSelected(obj);
    setModalMapaVisible(true);
  };

  const reset = async () => {
    setCargandoPage(true);
    iniciar();
  };

  const showToast = (message, type = "warning", durationMs = 3000) => {
    setToastMessage(message);
    setToastType(type);
    setToastVisible(true);
    // Auto-hide
    window.clearTimeout(showToast._timer);
    showToast._timer = window.setTimeout(() => {
      setToastVisible(false);
    }, durationMs);
  };

  const render = () => {
    try {
      // console.log('listar correo render');
      if (cargandoPage === true) {
        return cargandoCard();
      }
      if (tieneAccesoAlModulo === false) {
        return sinAccesoCard();
      }
      return (
        <div className="max-w-7xl mx-auto px-4 lg:px-6">
          <div className="flex items-center justify-between py-4">
            <div>
              <div className="flex items-center gap-2">
                {/* <ArrowBack onClick={handleAtrasClick} /> */}
                <h2 className="text-xl font-bold text-gray-900">{t("label_gestionar_incidentes")}</h2>
              </div>
              <p className="text-sm text-gray-500">{t("label_administra_la_lista_de_incidentes")}</p>
            </div>
            <div className="flex items-center gap-2">
              {/* <button
                type="button"
                className={ESTILO_BOTON_LISTAR_NUEVO}
                onClick={() => {
                  handleNuevoClick();
                }}
              >
                {t("label_nuevo")}
              </button> */}
            </div>
          </div>
          <div className="grid grid-cols-12 gap-4">
            <div className="col-span-12 md:col-span-6 lg:col-span-3 xl:col-span-3">
              <label className="block text-[#0F3457] font-semibold mb-2" htmlFor="label_fecha_inicio">
                {t("label_fecha_inicio")}
              </label>
              <Calendar
                value={fechaInicioSelected}
                onChange={(date) => setFechaInicioSelected(date)}
                placeholder={t("placeholder_seleccione_fecha")}
                id="fecha_inicio"
                name="fecha_inicio"
              />
            </div>
            <div className="col-span-12 md:col-span-6 lg:col-span-3 xl:col-span-3">
              <label className="block text-[#0F3457] font-semibold mb-2" htmlFor="label_fecha_fin">
                {t("label_fecha_fin")}
              </label>
              <Calendar
                value={fechaFinSelected}
                onChange={(date) => setFechaFinSelected(date)}
                placeholder={t("placeholder_seleccione_fecha")}
                id="fecha_fin"
                name="fecha_fin"
              />
            </div>
            {btnBuscar === true && (
              <div className="col-span-12 md:col-span-6 lg:col-span-3 xl:col-span-3">
                <label className="block text-[#0F3457] font-semibold mb-2" htmlFor="habilitado">
                  &nbsp;
                </label>
                <button
                  type="button"
                  className={ESTILO_BOTON_MODAL_ACEPTAR}
                  onClick={() => { reset(); }}
                >
                  {t("label_buscar")}
                </button>
              </div>
            )}
          </div>
          <br />
          {/* Grid Card */}
          <div className="bg-white border border-gray-200 rounded-lg p-2">
            <div className="min-h-[400px]">
              <div
                id="gridContainer"
                style={{
                  height: "100%",
                  width: "100%",
                }}
              />
            </div>
          </div>

          <ProcessingDialog visible={processingVisible} message={t("alert_procesando_solicitud")} />
          <ToastComponent
            visible={toastVisible}
            message={toastMessage}
            type={toastType}
            onClose={() => setToastVisible(false)}
          />
          <ModalMapaIncidente
            visible={modalMapaVisible}
            incidente={incidenteMapaSelected}
            onClose={() => setModalMapaVisible(false)}
          />
        </div>
      );
    } catch (err) {
      console.log('ListarPais render err');
      console.log(err);
      return (
        <div><label>{JSON.stringify(err)}</label></div>
      );
    }
  }

  return render();
}
